// ============================================================
// Datei: src/pages/ressorts/programm/Kommunikation.jsx
// ============================================================

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../../../styles/global.css";
import "../../../styles/ressortTabs.css";
import "../../../styles/ccMailCard.css";

import useVolunteers from "../../../components/fetch/useVolunteers";
import useShifts from "../../../components/fetch/useShifts";
import Api from "../../../Api";

import KommunikationDesktop from "./KommunikationDesktop";
import KommunikationMobile from "./KommunikationMobile";
import useMediaQuery from "../../../hooks/useMediaQuery";

const Kommunikation = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");
	const navigate = useNavigate();

	// ============================================================
	// Volunteers + Reload-Funktion (NEU)
	// ============================================================
	const volunteersHook = useVolunteers("Kommunikation");

	// 🔒 rückwärtskompatibel:
	// falls Hook noch NUR [volunteers, setVolunteers] liefert
	const volunteers = volunteersHook[0];
	const setVolunteers = volunteersHook[1];
	const reloadVolunteers = volunteersHook[2]; // kann undefined sein

	const [shifts] = useShifts("Kommunikation");

	const [selectedVolunteer, setSelectedVolunteer] = useState(null);
	const [guests, setGuests] = useState([]);
	const [activeTab, setActiveTab] = useState("overview");

	// ============================================================
	// Security
	// ============================================================
	useEffect(() => {
		const role = localStorage.getItem("role");
		const dept = localStorage.getItem("department");

		if (role !== "OK" || dept?.toLowerCase() !== "kommunikation") {
			alert("Zugriff verweigert!");
			navigate("/home");
			return;
		}

		loadGuests();
	}, [navigate]);

	const loadGuests = () => {
		Api.get("/guests").then(res => setGuests(res.data));
	};

	// ============================================================
	// CC-Mail-Liste herunterladen (OK + Programm)
	// ============================================================
	const downloadCcEmails = async () => {
		try {
			const res = await Api.get("/cc-emails", {
				responseType: "blob"
			});

			if (!res.data || res.data.size === 0) {
				throw new Error("Leere Datei");
			}

			const blob = new Blob([res.data], { type: "text/plain" });
			const url = window.URL.createObjectURL(blob);

			const a = document.createElement("a");
			a.href = url;
			a.download = "helferfest_cc_liste.txt";
			document.body.appendChild(a);
			a.click();
			a.remove();

			window.URL.revokeObjectURL(url);

		} catch (err) {
			console.error("CC-Download Fehler:", err);
			alert("Download fehlgeschlagen");
		}
	};

	// ============================================================
	// Props für Desktop & Mobile
	// ============================================================
	const layoutProps = {
		volunteers,
		setVolunteers,

		// wird nach Statusänderungen aufgerufen
		reloadVolunteers,

		shifts,
		guests,
		selectedVolunteer,
		setSelectedVolunteer,
		activeTab,
		setActiveTab,
		reloadGuests: loadGuests,
		downloadCcEmails
	};

	return (
		<div
			className="kommunikation-page bg-reveal"
			data-bg={`${process.env.PUBLIC_URL}/backgrounds/background_kommunikation.jpg`}
		>
			<h2 className="kommunikation-heading">Kommunikation</h2>

			{isMobile
				? <KommunikationMobile {...layoutProps} />
				: <KommunikationDesktop {...layoutProps} />
			}
		</div>
	);
};

export default Kommunikation;
